<ng-container *ngIf="machine">
  <h4><p class="text-center">{{machine.name}} bewerken</p></h4>

  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-12">
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Naam</strong></label>
            <div class="col-md-9 col-sm-12">
              <input class="form-control" [(ngModel)]="machine.name" type="text">
              <pre class="alert alert-danger" *ngIf="error">{{error}}</pre>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Nummer</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.number" type="text"></div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Bouwjaar</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.manufactureYear" type="text"></div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Serienummer</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.serial" type="text"></div>
          </div>
          <div class="form-group row" *ngIf="isAdmin()">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Prijs</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.price" type="text"></div>
          </div>
          <div class="form-group row" *ngIf="isAdmin()">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Leverdatum</strong></label>
            <div class="col-md-9 col-sm-12">
              <p-calendar dateFormat="dd-mm-yy" [(ngModel)]="supplyDate"></p-calendar>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Bijzonderheden</strong></label>
            <div class="col-md-9 col-sm-12"><textarea class="form-control" [(ngModel)]="machine.notes"></textarea></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h5><p class="text-center">Details</p></h5>
  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Vermogen</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.vermogen" /></div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Spanning</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.spanning" /></div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>P-onbelast</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.ponbelast" /></div>
          </div>
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Delta-p</strong></label>
            <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.deltap" /></div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="form-group row">
            <label class="col-form-label col-md-3 col-sm-12"><strong>Type</strong></label>
            <div class="col-md-9 col-sm-12">
              <p-dropdown [options]="machineTypes" [(ngModel)]="machine.type"></p-dropdown>
            </div>
          </div>
          <ng-container *ngIf="machine.type !== 'Compressor'">
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Filter elem</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.filterelem" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Filter elem prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.filterelemprice" type="text"></div>
            </div>
          </ng-container>
          <ng-container *ngIf="machine.type === 'Compressor'">
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Compressor type</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.compressortype" type="text"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Drukschakelaar</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.pressureswitch" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Drukschakelaar prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.pressureswitchPrice" type="text"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Seperator elem</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.seperatorelem" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Seperator elem prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.seperatorelemPrice" type="text"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Oliefilter</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.oilfilter" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Oliefilter prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.oilfilterPrice" type="text"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Luchtfilter</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.airfilter" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>Luchtfilter prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.airfilterPrice" type="text"></div>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-md-3 col-sm-12"><strong>V-snaar</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.vbelt" type="text"></div>
            </div>
            <div class="form-group row" *ngIf="isAdmin()">
              <label class="col-form-label col-md-3 col-sm-12"><strong>V-snaar prijs</strong></label>
              <div class="col-md-9 col-sm-12"><input class="form-control" [(ngModel)]="machine.vbeltPrice" type="text"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="row ui-toolbar">
    <div class="col-md-6">
      <button type="button" class="btn btn-primary" (click)="saveMachine()">
        Opslaan
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
        Annuleren
      </button>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/machine/edit/machine.edit.component.html